<template>
  <section id="contact" class="contact section-show">
    <div class="container">
      <div class="section-title">
        <h2>تغییر رمز عبور</h2>
      </div>
      <form method="post" class="email-form mt-4" @submit="checkForm">
        <div class="row d-flex justify-content-center">
          <div class="col-md-5 form-group mt-3 mt-md-0">
            <label class="label">رمز عبور جدید<img :src="star" /></label>
            <input
              id="newpass"
              class="form-control"
              type="text"
              v-model="ChangePass.newpass"
            />
            <p class="error" v-if="this.errors.newpass">
              <b>لطفا رمز عبور جدید خود راواردنمایید</b>
            </p>
            <label class="label">تکرار رمز عبور جدید<img :src="star" /></label>
            <input
              id="repeatnewpass"
              class="form-control"
              type="text"
              v-model="ChangePass.repeatnewpass"
            />
            <p class="error" v-if="this.errors.repeatnewpass">
              <b>لطفا تکرار رمز عبور جدید خود راواردنمایید</b>
            </p>
          </div>
        </div>
        <div class="text-center" style="margin-top: 20px">
          <button type="submit" class="btnsend">ثبت تغییرات</button>
        </div>
      </form>
    </div>
  </section>
</template>
<script>
import { ChangePassword } from "@/API/API";
import star from "../assets/img/star.png";
export default {
  name: "changepassword",
  data() {
    return {
      star,
      ChangePass: {
        newpass: "",
        repeatnewpass: "",
      },
      ChangePassword: {
        seq: "",
        PassWord: "",
      },
      errors: {
        newpass: "",
        repeatnewpass: "",
        sampass: "",
        length: 0,
      },
    };
  },
  methods: {
    checkForm: function (e) {
      e.preventDefault();
      this.errors = [];

      if (!this.ChangePass.newpass) {
        this.errors.newpass = true;
        this.errors.length += 1;
      }
      if (!this.ChangePass.repeatnewpass) {
        this.errors.repeatnewpass = true;
        this.errors.length += 1;
      }
      let npass = document.getElementById("newpass").value;
      let rnpass = document.getElementById("repeatnewpass").value;
      if (!npass == rnpass) {
        this.errors.sampass = true;
        this.errors.length += 1;
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "رمزعبور وتکرارآن یکسان نیست",
          confirmButtonColor: "#900C3F",
          confirmButtonText: "باشه",
        });
      }
      if (this.errors.length == 0) {
        this.ChangePassword = {
          seq: this.$store.getters.seq,
          PassWord: this.ChangePass.newpass,
        };
        ChangePassword(this.ChangePassword)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "موفق",
              text: "عملیات باموفقیت انجام شد",
              confirmButtonColor: "#1e682d",
              confirmButtonText: "باشه",
            });
            this.$router.push("/login");
          })
          .catch(() => {
            this.$swal({
              icon: "error",
              title: "خطا",
              text: "عملیات باشکست مواجه شد",
              confirmButtonColor: "#900C3F",
              confirmButtonText: "باشه",
            });
          });
      }
    },
  },
};
</script>
<style scoped>
.section-title h2 {
  font-size: 18px;
  font-weight: 700;
  padding: 0;
  line-height: 18px;
  margin: 30px 0 20px 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #111;
  font-family: "iransans", Lato, sans-serif;
  padding-bottom: 15px;
  position: relative;
}
.section-title h2::after {
  content: "";
  width: 140px;
  height: 2px;
  background: #d1a44f;
  bottom: 0;
  top: auto;
  position: absolute;
  right: 0;
}
</style>
